export default __webpack_public_path__ + "static/media/Snd_ClowerH.44b09755.mp3";